import React from "react";
import Server from "./Server.js";
import { Toast } from "primereact/toast";
import { connect } from "react-redux";
import { Carousel } from 'antd';
import { Radio } from 'antd';
import { Button  } from 'antd';
import { Input, InputNumber , Divider } from 'antd';
import Header from './Header.js'

import { RightCircleOutlined, LeftCircleOutlined } from '@ant-design/icons';
class Poll extends React.Component {
  constructor(props) {
    super(props);
    this.toast = React.createRef();
    this.Server = new Server();
    this.state = {
      appData: this.props.appData,
      username: "",
      placeSet: "",
      Logo: "",
      showAd: false,
      Tel: "",
      place: (this.Server.getSystem() && this.Server.getSystem().place) || this.Server.getPlace(),
      ShowLoading: false,
      showWebElements: false,
      chacheVersion: 2,
      ads: {},
      systems: [],
      absoluteUrl: this.Server.getAbsoluteUrl(),
      System: this.Server.getSystem(),
      poll: this.props.poll || {} ,
      questions:[]
    };
    this.carousel = React.createRef();
  }
  componentDidMount() {
    this.setState({
      getUsername: true
    })
    if(this.props.poll)
      this.getQuestionsOfPoll();
    else
      this.getPoll();
  }
  getPoll(){
    let that = this;
    this.Server.send(
      "https://newcrm.iran.liara.run/AdminApi/getPollInApp",
      {},
      function (response) {
        if(response.data.result && response.data.result[0]){
          that.setState({
            showPoll: true,
            poll: response.data.result[0]
          },()=>{
            that.getQuestionsOfPoll();

          })
        }
      },
      function () {
       
      },
    true);
  }
  
  getQuestionsOfPoll(){
    let that = this;
    this.Server.send(
      "https://newcrm.iran.liara.run/AdminApi/getQuestionsOfPoll",
      {questionIds:that.state.poll.questions.map((item)=>{return item.id})},
      function (response) {
        if(response.data.result){
          that.setState({
            questions:  response.data.result
          })
        }
      },
      function () {
       
      },
    true);
  }

  sendAnswer(){
    let that = this;
    let answers =[];
    for(let i =0; i<this.state.questions.length;i++){
      answers.push({
        _id : this.state.questions[i]._id,
        answer: this.state["question_"+ i],
      })
    }
    this.Server.send(
      "https://newcrm.iran.liara.run/AdminApi/setPollAnswer",
      {pollId: that.state.poll._id, mobile: that.state.username.toString(), name: this.state.name || "-", answers: answers},
      function (response) {
        that.toast.current.show({
          severity: "success",
          summary: <div className="iranyekanwebmedium">ذخیره اطلاعات</div>,
          detail: <div className="iranyekanwebmedium">پاسخ های شما با موفقیت ثبت شد</div>,
          life: 4000,
        });
        setTimeout(()=>{
          if(that.props.afterEnd){
            that.props.afterEnd();
          }
        },4000)
        
      },
      function (error) {
        that.toast.current.show({
          severity: "error",
          summary: <div className="iranyekanwebmedium">ذخیره اطلاعات</div>,
          detail: <div className="iranyekanwebmedium">خطا در ذخیره اطلاعات. لطفا مجددا تلاش کنید</div>,
          life: 4000,
        });
      },
    true);
  }

  render() {

    const states = this.state;
    let answeredLength = 0;
    for(const state in states){
      if(state.indexOf("question_") > -1){
        answeredLength++;
      }
    }

    return (

      <div
        style={{
                backgroundSize:'cover',
                padding: 14,
                borderRadius: 14,
                width: "100%",
                height: "100%",
                direction:'rtl'
              }
        }
      >
        {!this.props.noHeader &&
           <Header  ComponentName="مسابقه" ComponentLName={this.props.ComponentLName} />
        }
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />
        <div style={{background:'rgba(255,255,255,0.7)',borderRadius:10}}>
        <div style={{display:'flex',flexDirection:'column',justifyContent:'space-between',alignItems:'center'}}>
          <h2>
            {this.state.poll.name}
          </h2>
          <span style={{textAlign:'right'}}>
            {this.state.poll.desc}
          </span>

          </div>

          <Divider />
          
          {this.state.startPoll ? 
            <div style={{height:'100%',padding:10}}>
          <Carousel dots={false} ref={node => (this.carousel = node)} style={{height:'100%'}} dotPosition="bottom" effect="fade"  afterChange={()=>{
              
            }}>
            {this.state.poll &&  this.state.questions.map((question, index)=>{
                return (
                    <div>
                        <div  style={{textAlign:'center',color:"#000"}}>{question.text}</div>

                        <Radio.Group style={{display:'flex',flexDirection:'column',direction:'rtl',color:'#000',minHeight:250,justifyContent:'space-around'}} onChange={(event)=>{
                          this.setState({
                            ["question_"+index]: event.target.value
                          })
                        }} value={this.state["question_"+index]}>
                          {question.options.map((option)=>{
                            return(
                              <Radio value={option.id}>{option.title}</Radio>
                            )
                          })}
                        </Radio.Group>
                        
                          <div style={{display:'flex', justifyContent:'space-around'}}>
                          {this.state.questions.length-1 > index &&
                          <div style={{display:'flex',justifyContent:'center'}}>
                          <Button onClick={()=>{
                            this.carousel.next();
                          }} icon={<LeftCircleOutlined />} disabled={!this.state["question_"+index]} >سوال بعد</Button>
                          </div>
                          }
                          {index != 0 &&
                            <div style={{display:'flex',justifyContent:'center'}}>
                            <Button onClick={()=>{
                              this.carousel.prev();
                            }} icon={<RightCircleOutlined />} >سوال قبل</Button>
                            </div>  
                          }
                          </div>
                    </div>
                    
                )
            })}

            
            </Carousel>

            
            <div style={{display:'flex',justifyContent:'center',marginTop:20}} block>
                  <Button type="primary"  disabled={answeredLength !== this.state.questions.length} block onClick={()=>{
                    this.sendAnswer();
                  }} > {(this.state.questions.length - answeredLength) === 0 ? " ارسال پاسخ" : " سوالات باقیمانده :" + (this.state.questions.length - answeredLength)} </Button>
              </div>
              </div>
            :
                <div style={{direction:'rtl',height:300,padding:10}}>
              <Input placeholder="نام و نام خانوادگی" value={this.state.name} style={{marginTop:20}} onChange={(event)=>{
                  this.setState({
                    name: event.target.value
                  })
                }} />

              <InputNumber min={1}  placeholder="تلفن همراه" value={this.state.username} style={{marginTop:20,marginBottom:20, width:"100%"}} onChange={(value)=>{
                  this.setState({
                    username: value
                  })
                }} />

                <div style={{display:'flex',justifyContent:'center',marginTop:20}} block>
                  <Button type="primary" disabled={!this.state.username}  block onClick={()=>{
                    this.setState({
                      startPoll: true
                    })
                  }} >ثبت اطلاعات و شروع</Button>
              </div>
          </div>

          }
        </div>
          
          
            

             
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    LoginAnia: state.LoginAnia,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
};
export default connect(mapStateToProps)(Poll);
